import { CustomTypographyComponentProps } from "../types";
import { Typography } from "@mui/material";

export const Body2Typography = ({
  children,
  ...props
}: CustomTypographyComponentProps) => {
  return (
    <Typography variant="body2" {...props}>
      {children}
    </Typography>
  );
};
